'use client';
import './Dialog.css';
import { ReactNode } from 'react';
import { Variant } from '../../core/ui';
import SlDialog from '@shoelace-style/shoelace/dist/react/dialog/index.js';
import SlIcon from '@shoelace-style/shoelace/dist/react/icon/index.js';

interface DialogProps {
	variant: Variant;
	title: string;
	isOpen: boolean;
	onAfterHide: () => void;
	actions?: ReactNode;
	className?: string;
	children?: ReactNode;
	[key: string]: any;
}

const Dialog = ({
	variant,
	title,
	isOpen,
	onAfterHide,
	actions,
	className,
	children,
	...rest
}: DialogProps) => {
	let icon: ReactNode, color: string;
	switch (variant) {
		case 'danger':
			icon = <SlIcon name='exclamation-circle-fill'></SlIcon>;
			color = 'var(--sl-color-danger-600)';
			break;
		default:
			color = 'var(--sl-color-neutral-600)';
			break;
	}

	return (
		<SlDialog
			{...rest}
			open={isOpen}
			onSlAfterHide={onAfterHide}
			className={`dialog${className != null ? ' ' + className : ''}`}
			style={{ '--dialog-color': color } as React.CSSProperties}
		>
			<div className='dialog__icon'>{icon}</div>
			<div className='dialog__title'>{title}</div>
			<div className='dialog__content'>{children}</div>
			<div className='dialog__actions'>{actions}</div>
		</SlDialog>
	);
};

export { Dialog };
